import React from 'react'
import MessagesBoard from "../../ui/messages/MessagesBoard";

const Messages = () => {
    return (
        <div>
            <MessagesBoard/>
        </div>
    )
}

export default Messages;